// Ported verbatim from design_handoff/components.jsx::Logo — the SVG
// moose-head mark. The wordmark text is replaced with "Buaforsälgar" in App.tsx
// per the cross-cutting decision.
export function Logo() {
  return (
    <svg viewBox="0 0 64 64" fill="none">
      <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 22 L14 14 M22 22 L10 22 M22 22 L14 30 M22 22 L20 12" />
        <path d="M42 22 L50 14 M42 22 L54 22 M42 22 L50 30 M42 22 L44 12" />
      </g>
      <path
        d="M22 22 Q22 32 26 36 L26 48 Q26 52 30 52 L34 52 Q38 52 38 48 L38 36 Q42 32 42 22 Z"
        fill="currentColor"
      />
      <circle cx="29" cy="32" r="1.4" fill="#0c100d" />
      <circle cx="35" cy="32" r="1.4" fill="#0c100d" />
    </svg>
  );
}
